// @ts-nocheck
export const OPEN_TRAVEL_DAYS_MODAL = "OPEN_TRAVEL_DAYS_MODAL";

export const CLOSE_TRAVEL_DAYS_MODAL = "CLOSE_TRAVEL_DAYS_MODAL";

// save travel date
export const ADD_TRAVEL_DAYS_REQUEST = "ADD_TRAVEL_DAYS_REQUEST";
export const ADD_TRAVEL_DAYS_SUCCESS = "ADD_TRAVEL_DAYS_SUCCESS";
export const ADD_TRAVEL_DAYS_FAILURE = "ADD_TRAVEL_DAYS_FAILURE";